import { render, staticRenderFns } from "./BaseModalFront.vue?vue&type=template&id=df87d16a"
import script from "./BaseModalFront.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseModalFront.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports